import { createApp } from "vue";
import mitt from 'mitt';
import App from "./App.vue";
import VueGtag from "vue-gtag";
import router from "./router";
import store from "./store";

// import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

// Import Bootstrap an BootstrapVue CSS files (order is important)
// import "bootstrap/dist/css/bootstrap.css";

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import { faArrowUpRightFromSquare, faCopy, faBars, faClose, faPaperclip, faPaperPlane, faCheck, faPlus, faHome, faEyeSlash, faEye, faKey, faIdCard, faTimesCircle, faExclamationCircle, faDownload,
  faFile, faLongArrowRight, faLock, faUser, faArrowAltCircleUp, faCamera, faTrash, faSave, faEarthAsia, faTree, faShare, faHeart, faTag, faChevronLeft, faChevronRight,
faCog, faUserPlus, faFileAlt, faList, faChartLine, faClock, faWrench, faRefresh, faExchange, faMobileAndroid, faPencil, faEnvelope, faWindowMaximize, faArrowCircleUp, faDisplay, faWindowRestore } from '@fortawesome/free-solid-svg-icons'
import { } from '@fortawesome/free-regular-svg-icons';

import { faAndroid, faAppStore, faGooglePlay } from '@fortawesome/free-brands-svg-icons'

/* add icons to the library */
library.add( faAppStore, faGooglePlay, faArrowUpRightFromSquare, faCopy, faAndroid, faBars, faClose, faPaperclip, faPaperPlane, faCheck, faPlus, faHome, faEyeSlash, faEye, faKey, faIdCard, faTimesCircle, faExclamationCircle, faDownload,
  faFile, faLongArrowRight, faLock, faUser, faArrowAltCircleUp, faCamera, faTrash, faSave, faEarthAsia, faTree, faShare, faHeart, faTag, faChevronLeft, faChevronRight,
  faCog, faUserPlus, faFileAlt, faList, faChartLine, faClock, faWrench, faRefresh, faExchange, faMobileAndroid, faPencil, faEnvelope, faWindowMaximize, faArrowCircleUp, faDisplay, faWindowRestore )


const integrateConfig = async() => {
  try{
    const storedConfig = await fetch("/config.json").then(function (res) {
      return res.json();
    }).then(function (data) {
      return data;
    })

    if(storedConfig.version != localStorage.getItem('version')){
      localStorage.removeItem('version');
      localStorage.removeItem('testnetUrl');
      localStorage.removeItem('testnetLabel');
      localStorage.removeItem('testnetApi');
      localStorage.removeItem('testnetNetworkType');
      localStorage.removeItem('testnetExplorer');
      localStorage.removeItem('testnetWebWallet');
      localStorage.removeItem('testnetGenerationHash');
      localStorage.removeItem('testnetXPXAssetId');
      localStorage.removeItem('mainnetUrl');
      localStorage.removeItem('mainnetLabel');
      localStorage.removeItem('mainnetApi');
      localStorage.removeItem('mainnetExplorer');
      localStorage.removeItem('mainnetWebWallet');
      localStorage.removeItem('mainnetGenerationHash');
      localStorage.removeItem('mainnetXPXAssetId');
      localStorage.removeItem('assetUrl');
      localStorage.removeItem('GAnalyticsID');
      localStorage.removeItem('Testnet2MobileApkVersion');
      localStorage.removeItem('enableMainnet');
      localStorage.setItem("version", JSON.stringify(storedConfig.version));
      localStorage.setItem("testnetUrl", JSON.stringify(storedConfig.testnetUrl));
      localStorage.setItem("testnetLabel", JSON.stringify(storedConfig.testnetLabel));
      localStorage.setItem("testnetApi", JSON.stringify(storedConfig.testnetApi));
      localStorage.setItem("testnetNetworkType", JSON.stringify(storedConfig.testnetNetworkType));
      localStorage.setItem("testnetExplorer", JSON.stringify(storedConfig.testnetExplorer));
      localStorage.setItem("testnetWebWallet", JSON.stringify(storedConfig.testnetWebWallet));
      localStorage.setItem("testnetGenerationHash", JSON.stringify(storedConfig.testnetGenerationHash));
      localStorage.setItem("testnetXPXAssetId", JSON.stringify(storedConfig.testnetXPXAssetId));
      localStorage.setItem("mainnetUrl", JSON.stringify(storedConfig.mainnetUrl));
      localStorage.setItem("mainnetLabel", JSON.stringify(storedConfig.mainnetLabel));
      localStorage.setItem("mainnetApi", JSON.stringify(storedConfig.mainnetApi));
      localStorage.setItem("mainnetNetworkType", JSON.stringify(storedConfig.mainnetNetworkType));
      localStorage.setItem("mainnetExplorer", JSON.stringify(storedConfig.mainnetExplorer));
      localStorage.setItem("mainnetWebWallet", JSON.stringify(storedConfig.mainnetWebWallet));
      localStorage.setItem("mainnetGenerationHash", JSON.stringify(storedConfig.mainnetGenerationHash));
      localStorage.setItem("mainnetXPXAssetId", JSON.stringify(storedConfig.mainnetXPXAssetId));
      localStorage.setItem("assetUrl", JSON.stringify(storedConfig.assetUrl));
      localStorage.setItem("GAnalyticsID", JSON.stringify(storedConfig.GAnalyticsID));
      localStorage.setItem("Testnet2MobileApkVersion", JSON.stringify(storedConfig.Testnet2MobileApkVersion));
      localStorage.setItem("enableMainnet", JSON.stringify(storedConfig.enableMainnet));
    }
    return storedConfig;
  }catch(err){
    console.error(err)
  }
}

(async() => {
  const emitter = mitt();
  const config = await integrateConfig();
  await store.dispatch('config/getconfig', config);
  const app = createApp(App).use(store).use(router).use(VueGtag, { config: { id: store.getters['config/GAnalyticsID'] }}).component('font-awesome-icon', FontAwesomeIcon);
  app.config.globalProperties.emitter = emitter;
  app.mount("#app");
})()


